module.exports = __webpack_public_path__ + "fonts/MarsCentra-Bold.8f1c4680.otf";